import $ from "jquery";

$(document).ready(function () {

	$('.register-siret input, .register-siret select').change(function(e){
		const ctx = $(this).closest('.woocommerce-form-row');
		if(ctx && ctx.length > 0 && ctx.hasClass('has-error')){
			ctx.removeClass('has-error')
		}
	})

	if ($('.woocommerce-registration-form-validate-vat')) {

		// Validation de l'étape TVA
		$('.woocommerce-registration-form-validate-vat').on('click', function (e) {
			e.preventDefault()
			// --- Validation du format de numéro TVA
			const ctx = $(this).closest('.woocommerce-registration-step-1');
			const vatInput = $('input[name="siret"]', ctx);
			const vatValue = vatInput.val();
			const vatInputRow = vatInput.closest('.woocommerce-form-row')
			const regex = /^[a-zA-Z0-9]+$/;
			if(!vatValue || !regex.test(vatValue)){
				vatInputRow.addClass('has-error');
				return;
			}

			$('.woocommerce-registration-step-1').addClass('hidden');
			$('.woocommerce-registration-step-2').addClass('shown');
		});

		// Validation des informations
		$('.woocommerce-registration-form-validate-info').on('click', function (e) {
			e.preventDefault()

			// Validation des emails
			const requiredFields = [
				'raison-sociale',
				'code-postal',
				'personne-contacter',
				'telephone'
			];

			const ctx = $('.woocommerce-registration-step-2');
			let isValid = true;

			requiredFields.forEach(function(field, fieldIndex){
				const inp = $('input[name="'+field+'"]', ctx);
				if(inp.val().trim() === ''){
					isValid = false;
					const inputRow = inp.closest('.woocommerce-form-row')
					inputRow.addClass('has-error')
					isValid = false;
				}
			});

			// Validation spécifique "email"
			const inpEmail = $('input[name="email"]');
			const regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

			if( !regexEmail.test(inpEmail.val()) ){
				const inputRow = inpEmail.closest('.woocommerce-form-row')
				inputRow.addClass('has-error')
				isValid = false;
			}
			// Validation spécificatique select "interessed-by"
			const inpInteressedBy= $('select[name="interessed-by"]');
			if( inpInteressedBy.val() === '' || inpInteressedBy.val() === null ){
				const inputRow = inpInteressedBy.closest('.woocommerce-form-row')
				inputRow.addClass('has-error')
				isValid = false;
			}

			// Validation spécifique checkbox : "optin"
			const inpOptIn = $('input[name="optin"]');
			if(!inpOptIn.is(':checked')){
				const inputRow = inpOptIn.closest('.woocommerce-form-row')
				inputRow.addClass('has-error')
				isValid = false;
			}

			if(isValid){
				$('.woocommerce-registration-step-2').removeClass('shown');
				$('.woocommerce-registration-step-3').addClass('shown');
			}

		});
	}
});